import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  messagesShow: ['data'],
  messagesDismiss: null,
});

export const MessagesTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: [],
});

/* ------------- Reducers ------------- */

// we've successfully ...
export const add = (state, {data}) => {
  let dt = [...state.data];
  dt.push(data);
  return state.merge({fetching: false, error: null, data: dt})
};

export const dismiss = (state) =>
  state.merge({fetching: false, error: null, data: state.data.slice(1)});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.MESSAGES_SHOW]: add,
  [Types.MESSAGES_DISMISS]: dismiss,
});
